import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import { StyleSheet, ScrollView, View } from 'react-native'
import { textStyles } from 'styles/text'
import Description from 'components/atoms/Description'
import React, { useState } from 'react'
import ThemedModal from 'components/atoms/ThemedModal'
import Button from "theme/Button";
import Text from "theme/Text";
import ManagementEmployeesEmployeeAdminRights from 'scenes/management/employees/components/adminRights'
import _ from 'lodash'
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationManagementUserEmployee from 'graphql/mutations/management/MutationManagementUserEmployee'
import MutationManagementEmployee from 'graphql/mutations/management/MutationManagementEmployee'
import VStack from 'components/atoms/stack/VStack'
import HStack from 'components/atoms/stack/HStack'
import HelperManagementRights from 'utils/helper-management-rights'

const EmployeeAdvanced = ({ employee }) => {
	
	const [ modalDelete, setModalDelete ] = useState( false )
	const [ submitDelete, setSubmitDelete ] = useState( false )
	
	const [ modalAdmin, setModalAdmin ] = useState( false )
	const [ submitAdmin, setSubmitAdmin ] = useState( false )
	
	const [ user, setUser ] = useState( _.get( employee, 'user', {} ) )
	
	const isAdmin = _.get( user, [ 'active' ], constantsGraphql.NO ) === constantsGraphql.YES;
	
	const onMutateAdmin = ( active = true ) => {
		new GraphqlBuilder()
			.addQuery('mutation_user_employee', MutationManagementUserEmployee, {
				employee_guid: employee.guid,
				active: (active === true) ? constantsActive.YES : constantsActive.NO
			})
			.setResultPath( [ 'mutation_user_employee', 'user_employee' ], null )
			.setOnStart( () => {
				setSubmitAdmin( true )
			})
			.setOnSuccess( result => {
				setSubmitAdmin( false )
				setUser( result )
			})
			.setOnError( result => {
				setSubmitAdmin( false )
			})
			.execute()
	}
	
	const onMutateDelete = () => {
		new GraphqlBuilder()
			.addQuery('mutation_employee', MutationManagementEmployee, {
				guid: employee.guid,
				active: 'no',
				gdpr: 'yes'
			})
			.setResultPath( [ 'mutation_employee', 'management_employee' ], null )
			.setOnStart( () => {
				setSubmitDelete( true )
			})
			.setOnSuccess( result => {
				setSubmitDelete( false )
				setModalDelete( false )
				setUser( result )
				
				//navigation.goBack();
			})
			.setOnError( result => {
				setSubmitDelete( false )
			})
			.execute()
	}
	
	return (
		<>
			<HStack>
				{/* Admin */}
				<ThemedBlock
					header={ i18n.t('management:pages.teams.employee.block_admin.title') }
					shadow
					mediumPadding>
					
					<View
						style={ textStyles.container }>
						
						<Description
							style={ textStyles.textCenter }>
							
							{ i18n.t('management:pages.teams.employee.block_admin.description') }
						</Description>
					</View>

					{ isAdmin ? (
						<>
						<VStack>
							<Button
								disabled={ !HelperManagementRights.canManageAdmin(employee) }
								onPress={ setModalAdmin.bind( this, true ) }>
								
								{ i18n.t('management:pages.teams.employee.block_admin.button_rights') }
							</Button>
							<Button
								appearance="ghost"
								disabled={ !HelperManagementRights.canManageAdmin(employee) }
								onPress={ onMutateAdmin.bind( this, false ) }
								isLoading={ submitAdmin }>
								
								{ i18n.t('management:pages.teams.employee.block_admin.button_delete') }
							</Button>
						</VStack>

						{ modalAdmin && (
							<ThemedModal
								visible={ true }
								setVisible={ setModalAdmin }
								title={ i18n.t('management:modal.user_rights.title') }
								style={ staticStyles.themedModalHeight600 }>
								
								<ScrollView
									style={ staticStyles.themedModalHeight600 }>
									
									<ManagementEmployeesEmployeeAdminRights
										employee={ employee }
									/>
								</ScrollView>
							</ThemedModal>
						)}
						</>
					):(
						<Button
							disabled={ !HelperManagementRights.canCreateAdmin(employee) }
							onPress={ onMutateAdmin.bind( this, true ) }
							isLoading={ submitAdmin }>
							
							{ i18n.t('management:pages.teams.employee.block_admin.button_create') }
						</Button>
					)}
				</ThemedBlock>
						
				{/* Delete */}
				<ThemedBlock
					header={ i18n.t('management:pages.teams.employee.block_account.title') }
					shadow
					mediumPadding>
					
					<View
						style={ textStyles.container }>
						
						<Description
							style={ textStyles.textCenter }>
							
							{ i18n.t('management:pages.teams.employee.block_account.description') }
						</Description>
					</View>
					
					<Button
						onPress={ setModalDelete.bind( this, !modalDelete ) }>
						
						{ i18n.t('management:pages.teams.employee.block_account.button_delete') }
					</Button>
				</ThemedBlock>
			</HStack>
			
			{/* Delete modal */}
			<ThemedModal
				visible={ modalDelete }
				setVisible={ setModalDelete }
				title={ i18n.t('management:modal.block_account.title') }
				footer={(
					<>
						<Button
							appearance="ghost"
							onPress={ setModalDelete.bind( this, false ) }>
							
							{ i18n.t('management:modal.basic.cancel' ) }
						</Button>
						
						<Button
							isLoading={ submitDelete }
							onPress={ onMutateDelete }>
							
							{ i18n.t('management:modal.block_account.button_confirm') }
						</Button>
					</>
				)}>
				
				<Text>{ i18n.t('management:modal.block_account.description') }</Text>
			</ThemedModal>
		</>
	)
}

const staticStyles = StyleSheet.create({
	themedModalHeight600: {
		height: 600,
	},
});

export default EmployeeAdvanced
